<template>
  <div class="tab_menu" :class="{'purchase': isPurchase}">
    <div v-for="tab in tabs" :key="tab.id"
        class="tab"
        :class="{ active: activeTab === tab.id ,'purchase': isPurchase}"
        @click="changeTab(tab)">
      {{ t(tab.label) }}
    </div>
  </div>
</template>

<script>
import t from '@/plugins/i18n';

export default {
  mixins: [t],
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    activeTab: {
      type: Number,
      default: 0,
    },
    isPurchase: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    changeTab(tab) {
      this.$emit('update-activeTab', tab.id);
      if (tab.route) {
        this.$router.push({ path: tab.route });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab_menu {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  background-color: #eeeeee;
  padding: 5px;
  border-radius: 10px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.5);
  &.purchase {
    align-items: center;
  }
  .tab {
    white-space: nowrap;
    font-weight: bold;
    padding: 5px 30px;
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;
    box-sizing: border-box;
    &.purchase {
      white-space: inherit;
    }
  }
  .tab.active {
    padding: 5px 30px;
    border-radius: 2px;
    background-color: white;
    outline: 2px solid #ccc;
  }
}
@media screen and (max-width: $tabletWidth) {
  .tab_menu {
    .tab {
      font-size: 15px !important;
      padding: 5px 20px !important;
      &.purchase {
        padding: 5px 10px !important;
      }
    }
    .tab.active {
      padding: 5px 20px !important;
      &.purchase {
        padding: 5px 10px !important;
      }
    }
  }
}
</style>
